import { db, storageRef } from "../firebase/config";

import path from "path";

const uploadCoverImage = (userID: string, file: File) => {
  const extension = path.extname(file.name);
  storageRef
    .child(`profiles/${userID}/cover${extension}`)
    .put(file)
    .then(async (snapshot) => {
      const url = await snapshot.ref.getDownloadURL();

      db.collection("profiles").doc(userID).set(
        {
          cover: url,
        },
        { merge: true }
      );
    })
    .catch((error) => console.error(error));
};

export default uploadCoverImage;
